import { NotificationData } from '../types/NotificationData';


/**
 * Creates a default NotificationData object with values from email config
 * @param emailConfig - Email configuration from environment
 * @returns NotificationData object with default values
 */
export const SetupNotificationDefaults = (emailConfig: { from: string; to: string; cc: string }): NotificationData => {
  return {
    from: emailConfig.from,
    to: emailConfig.to,
    cc: emailConfig.cc,
    subject: 'Flight Range Update Notification',
    userText: 'A change was made to the flight range.'
  };
};

/**
 * Parses a comma-separated string of email addresses into an array
 * @param emails - Comma-separated email addresses
 * @returns Array of trimmed email addresses
 */
export const parseEmailAddresses = (emails: string): string[] => {
  if (!emails || emails.trim() === '') {
    return [];
  }
  return emails.split(',').map(email => email.trim()).filter(email => email.length > 0);
};


